// pages/ContactPage.jsx
import React, { useEffect, useState } from 'react';

const ContactPage = () => {
  useEffect(() => {
    document.title = 'Contact - Xibaar Bambouck';
    return () => {
      document.title = 'Xibaar Bambouck';
    };
  }, []);

  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Intégration future avec un service de traitement (ex: Formspree, WP REST)
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow">
        <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">Contactez-nous</h1>
        {!submitted ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-gray-700">Nom</label>
              <input type="text" id="name" name="name" onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded" />
            </div>
            <div>
              <label htmlFor="email" className="block text-gray-700">Email</label>
              <input type="email" id="email" name="email" onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded" />
            </div>
            <div>
              <label htmlFor="message" className="block text-gray-700">Message</label>
              <textarea id="message" name="message" rows="5" onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded"></textarea>
            </div>
            <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700">
              Envoyer
            </button>
          </form>
        ) : (
          <div className="text-center text-green-600 text-lg font-semibold">
            Merci pour votre message ! Nous vous répondrons dans les plus brefs délais.
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactPage;
